/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { camelCase } from 'lodash';

import { Modal } from '@blend/enterprise-components';
import { ModalContent } from 'blb-components/ModalContent';
import { Footer } from './Footer';
import { TaskError } from '../Task/TaskError';

export interface TaskModalProps {
  alternateButtonLabel?: string;
  disabledReason?: string;
  divideFooter?: boolean;
  error?: string;
  // Click handler for optional secondary button in modal footer.
  handleAlternateClick?: () => void;
  handleClose: () => void;
  handleSubmit: () => void;
  isLoading?: boolean;
  isOpen: boolean;
  subTitle?: string;
  submitButtonDisabled?: boolean;
  submitButtonLabel?: string;
  taskId?: string;
  title: string;
}

export const TaskModal: React.FC<TaskModalProps> = ({
  alternateButtonLabel,
  submitButtonDisabled,
  children,
  disabledReason,
  divideFooter,
  error,
  handleClose,
  handleAlternateClick,
  handleSubmit,
  isLoading,
  isOpen,
  submitButtonLabel,
  subTitle,
  taskId,
  title,
}) => {
  const id = taskId || camelCase(title);
  return (
    <Modal contentLabel={title} handleClose={handleClose} isOpen={isOpen}>
      <ModalContent handleClose={handleClose} headerText={title} id={`it-task-${id}-modal`} subHeaderText={subTitle}>
        {error && <TaskError errorMessage={error} spacing="md" />}
        {children}
        <Footer
          alternateButtonLabel={alternateButtonLabel}
          disabledReason={disabledReason}
          footerId={`it-task-${id}-modal-footer`}
          handleAlternateClick={handleAlternateClick}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          showDivider={divideFooter}
          submitButtonDisabled={submitButtonDisabled}
          submitButtonLabel={submitButtonLabel}
        />
      </ModalContent>
    </Modal>
  );
};
